export default __webpack_public_path__ + "static/media/estimate_empty.0a2861ac.svg";